<template>
  <sweet-modal ref="preview_modal" blocking="blocking">
    <div class="row">
      <div class="col">
        <file-upload-collapsed @input="addImage" type="image"></file-upload-collapsed>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <table class="table text-left">
          <thead>
            <tr>
              <th style="width: 20%">{{ '#' }}</th>
              <th style="width: 20%">{{ 'image_tag' | t }}</th>
              <th style="width: 40%">{{ 'example' | t }}</th>
              <th style="width: 20%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(image, i) in images">
              <td><img :src="image.image" height="50" style="maxwidth: 200px" /></td>
              <td>
                <input class="form-control" v-model="image.tag" />
              </td>
              <td>
                {{ '&lt;img src=&quot;\{\{\ images.' + image.tag + ' }\}&quot;/>' }}
              </td>
              <td>
                <a @click="images.splice(i, 1)" href="#">{{ 'delete' | t }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Alerts from '@/utils/alerts';

export default {
  props: ['value'],
  data: function () {
    return {
      images: this.value
    };
  },

  methods: {
    addImage: function (e) {
      this.images.push({
        image: e,
        tag: Math.random().toString(36).substring(7) + Math.floor(Math.random() * 100 + 1)
      });
    },
    open: function () {
      this.$refs.preview_modal.open();
    },
    close: function () {
      this.$refs.preview_modal.close();
    }
  }
};
</script>

<style scoped></style>
